// FishButton -------------------------------------------------
function FishButton(clr, pos_x, pos_y) {

	//Import classes
	var Container = include('createjs.Container'),
		Sprite = include('createjs.Sprite'),
		EventDispatcher = include('springroll.EventDispatcher');

	// parameters	
	this.clr = clr;
	this.px = pos_x;
	this.py = pos_y;
	
	// objects 
	this.view = new Container();

	// set up function bindings
	this.playAnimation = this.playAnimation.bind(this);
	this.showFish = this.showFish.bind(this);

	this.init();

}

namespace('WGBH').FishButton = FishButton;

var p = FishButton.prototype;

// used to initialize the button
p.init = function() {
	this.view.x = this.px;
	this.view.y = this.py;
	// add bg
	this.bg = new createjs.Sprite(LOADED_OBJECTS.sprsheets.buttonanim_spr, 'start_anim');
	this.bg.gotoAndStop('start_anim');
	this.bg.visible = false;
	this.view.addChild(this.bg);

	this.fish = new Fish(this.clr, 0, true);
	this.fish.view.scaleX = this.fish.view.scaleY = app.config.GAME.BUTTONS.fish.scale;
	this.fish.view.x = app.config.GAME.BUTTONS.fish.x;
	this.fish.view.y = app.config.GAME.BUTTONS.fish.y;
	this.fish.view.visible = false;
	
	// add the accessibility button
	this.bt = new AccButton(
				(this.clr+'_bt'), 
				'',
				'',
				this.px,
				this.py, 
				app.config.GAME.BUTTONS.answers.width, 
				app.config.GAME.BUTTONS.answers.height,
				(app.config.GAME.LABELS[this.clr] + ' fish'),
				false
			);			
	app.acc_mgr.addInteractiveButton(this.bt);
	this.view.addChild(this.fish.view);
};

// used to start the animation with delay
p.startAnimation = function(delay) {
	if(delay !== 0) {
		this.anim_timer = new springroll.DelayedCall(this.playAnimation, delay, {repeat:false});	
	}
	else {
		this.playAnimation();
	} 
};

// used to play the animation
p.playAnimation = function() {
	this.bg.addEventListener('animationend', this.showFish);
	this.bg.visible = true;
	this.bg.gotoAndPlay('start_anim');
};

// used to display the fish after the bg comes into display
p.showFish = function() {
	this.bg.removeEventListener('animationend ', this.showFish);
	this.fish.view.visible = true;
};

// used to clear the object
p.clearObject = function() {
	this.bt.clearObject();
	while(this.view.numChildren > 0) {
		this.view.removeChildAt(0);
	}
	this.fish = null;
	this.bg = null;
	this.bt = null;
	this.view = null;
};
